/**
 * Casas y Más (casasymas.com.uy) — INF-2226. Es un clon de InfoCasas: hereda todo de
 * InfoCasasBrand (tipografía, breakpoints, spacing, tamaños, colores funcionales) y pisa sólo
 * lo de marca, logos y colores (laudo de pablo, 2026-10-21).
 *
 * Los colores salen del sistema de diseño del sitio actual
 * (`/assets/css/shared/general.css` y `header.css`, leídos el 2026-10-20):
 *   primary         = --color-cta-main (#C8643A) · hover/dark = --color-cta-main-hover (#A94F2D)
 *   primaryLight    = --color-brand-primary (#DCAB7C)
 *   secondary       = azul del header (#3A6D8C) · dark/hover = #2C4A63 · V2 / menú = #23394E
 *   textos          = --color-text-dark (#3B2A1E) · --color-text-soft (#6F5846)
 *   fondo alternativo = --color-bg-page (#FFF8F1)
 */
const InfoCasasBrand = require("./InfoCasasBrand");

const theme = {
	...InfoCasasBrand,
	images: {
		// Logos subidos por pablo al CDN de InfoCasas (INF-2225).
		logo: "https://cdn1.infocasas.com.uy/web/6ad79dfa40f61_logo_cabezal.png",
		// El favicon del sitio actual, subido por pablo al CDN de InfoCasas (INF-2226).
		isotipo: "https://cdn2.infocasas.com.uy/web/6ad802cbc1b8d_favicon.png",
		favicon: "https://cdn2.infocasas.com.uy/web/6ad802cbc1b8d_favicon.png",
		icono: "https://cdn2.infocasas.com.uy/web/6ad802cbc1b8d_favicon.png",
	},
	colors: {
		...InfoCasasBrand.colors,
		primaryColor: "#C8643A",
		primaryHoverColor: "#A94F2D",
		primaryDarkColor: "#A94F2D",
		primaryLightColor: "#DCAB7C",
		primaryColorV2: "#23394E",
		secondaryColor: "#3A6D8C",
		secondaryDarkColor: "#2C4A63",
		secondaryHoverColor: "#2C4A63",
		secondaryOpacityColor: "rgba(58, 109, 140, 0.25)",
		textColorHigh: "#3B2A1E",
		textColorMedium: "#3B2A1E",
		textColorLow: "#6F5846",
		textSecondaryColor: "#6F5846",
		textLinkSecondary: "#3A6D8C",
		backgroundMainColor: "#C8643A",
		backgroundMenuColor: "#23394E",
		linkColor: "#C8643A",
		linkHoverColor: "#A94F2D",
		backgroundColorAternative: "#FFF8F1",
		contentButtonColor: "#C8643A",
		backgroundHighColor: "#A94F2D",
		backgroundMediumColor: "#DCAB7C",
	},
};

module.exports = theme;
